import React from 'react';
import {
  Box, Button, CardActions,
  CardContent,
  Checkbox,
  Dialog,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Typography,
} from '@mui/material';

function TaskFiltersDialog({
  open, setOpen, careType, setCareType, appliedCareType, setAppliedCareType,
  species, setSpecies, appliedSpecies, setAppliedSpecies,
}: {
  open: boolean,
  setOpen: React.Dispatch<React.SetStateAction<boolean>>,
  careType: {
    adopted: boolean,
    fostered: boolean,
    preSurrender: boolean,
  } | null,
  setCareType: React.Dispatch<React.SetStateAction<{
    adopted: boolean,
    fostered: boolean,
    preSurrender: boolean,
  } | null>>,
  appliedCareType: {
    adopted: boolean,
    fostered: boolean,
    preSurrender: boolean,
  } | null,
  setAppliedCareType: React.Dispatch<React.SetStateAction<{
    adopted: boolean,
    fostered: boolean,
    preSurrender: boolean,
  } | null>>,
  species: {
    dogs: boolean,
    cats: boolean,
  } | null,
  setSpecies: React.Dispatch<React.SetStateAction<{
    dogs: boolean,
    cats: boolean,
  } | null>>,
  appliedSpecies: {
    dogs: boolean,
    cats: boolean,
  } | null,
  setAppliedSpecies: React.Dispatch<React.SetStateAction<{
    dogs: boolean,
    cats: boolean,
  } | null>>,
}) {
  const handleClose = () => {
    setOpen(false);
    setCareType(appliedCareType);
    setSpecies(appliedSpecies);
  };

  const applyFilters = () => {
    setOpen(false);
    setAppliedCareType(careType);
    setAppliedSpecies(species);
    if (careType && Object.keys(careType).length > 0) {
      localStorage.setItem('notificationCareType', JSON.stringify(careType));
    } else {
      localStorage.removeItem('notificationCareType');
    }
    if (species && Object.keys(species).length > 0) {
      localStorage.setItem('notificationSpecies', JSON.stringify(species));
    } else {
      localStorage.removeItem('notificationSpecies');
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="filter-dialog-title"
      aria-describedby="filter-dialog-description"
      PaperProps={{
        sx: {
          width: '600px',
          maxWidth: '90vw',
        },
      }}
      maxWidth={false}
    >
      <DialogTitle id="logout-dialog-title">
        <Typography variant="h6bold">Filters</Typography>
      </DialogTitle>
      <CardContent>
        <Box sx={{ display: 'flex', gap: 6 }}>
          <Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>Care Type</Typography>
            <FormGroup>
              <FormControlLabel
                control={(
                  <Checkbox
                    checked={careType?.adopted}
                    onChange={(e) => setCareType((prev) => {
                      if (!prev) return null;
                      return { ...prev, adopted: e.target.checked };
                    })}
                  />
                )}
                label="Adopted Pets"
              />
              <FormControlLabel
                control={(
                  <Checkbox
                    checked={careType?.fostered}
                    onChange={(e) => setCareType((prev) => {
                      if (!prev) return null;
                      return { ...prev, fostered: e.target.checked };
                    })}
                  />
                )}
                label="Fostered Pets"
              />
              <FormControlLabel
                control={(
                  <Checkbox
                    checked={careType?.preSurrender}
                    onChange={(e) => setCareType((prev) => {
                      if (!prev) return null;
                      return { ...prev, preSurrender: e.target.checked };
                    })}
                  />
                )}
                label="Pets at risk of surrender"
              />
            </FormGroup>
          </Box>
          <Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>Species</Typography>
            <FormGroup>
              <FormControlLabel
                control={(
                  <Checkbox
                    checked={species?.dogs}
                    onChange={(e) => setSpecies((prev) => {
                      if (!prev) return null;
                      return { ...prev, dogs: e.target.checked };
                    })}
                  />
                )}
                label="Dogs"
              />
              <FormControlLabel
                control={(
                  <Checkbox
                    checked={species?.cats}
                    onChange={(e) => setSpecies((prev) => {
                      if (!prev) return null;
                      return { ...prev, cats: e.target.checked };
                    })}
                  />
                )}
                label="Cats"
              />
            </FormGroup>
          </Box>
        </Box>
      </CardContent>
      <CardActions>
        <Button variant="contained" onClick={applyFilters}>Save Changes</Button>
        <Button onClick={handleClose}>Cancel</Button>
      </CardActions>
    </Dialog>
  );
}

export default TaskFiltersDialog;
